module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#crime",
      toString: function () {
        return this.url;
      }
    }